module.exports = __webpack_public_path__ + "img/midland-trade-logo-black.11a4747f.svg";